/**
 * Database Initializer Component
 * Handles IndexedDB initialization and migration (non-blocking).
 * Renders children immediately — IndexedDB opens in ~50ms.
 */

import React, { useEffect, useState } from 'react';
import sqliteService from '../services/sqliteService';
import migrationService from '../services/migrationService';
import './DatabaseInitializer.css';

const DatabaseInitializer = ({ children, onInitialized }) => {
    const [error, setError] = useState(null);

    useEffect(() => {
        initializeDatabase();
    }, []);

    const initializeDatabase = async () => {
        try {
            // Step 1: Initialize IndexedDB (~50-100ms)
            const initSuccess = await sqliteService.initialize();

            if (!initSuccess) {
                throw new Error('Failed to initialize database');
            }

            // Step 2: Migrate from localStorage if needed (one-time, first visit)
            if (migrationService.isMigrationNeeded()) {
                await migrationService.migrate();
                console.log('✅ Migration complete');
            }

            // Step 3: Deferred background tasks (non-blocking)
            setTimeout(() => {
                migrationService.cleanupExpiredBackups();
            }, 5000);

            if (onInitialized) {
                onInitialized();
            }

        } catch (err) {
            console.error('Database initialization error:', err);
            setError(err.message);
        }
    };

    // Only show error screen if IndexedDB truly fails (rare)
    if (error) {
        return (
            <div className="db-initializer-overlay">
                <div className="db-initializer-content error">
                    <div className="db-initializer-icon">❌</div>
                    <h2>Database Initialization Failed</h2>
                    <p className="error-message">{error}</p>
                    <button
                        className="retry-btn"
                        onClick={initializeDatabase}
                    >
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    // Render children immediately — no blocking spinner
    return <>{children}</>;
};

export default DatabaseInitializer;

